import once from 'once'

function attach(selector) {
  const calcHeight = () => {
    calculateHeight(selector)
  }
  window.addEventListener('resize', calcHeight)
  window.addEventListener('orientationchange', calcHeight)
}

function calculateHeight(selector) {
  if (selector) {
    selector.height = `${selector.contentWindow.document.body.scrollHeight}`
  }
}

export default function iframeLoaded(
  selector = document.getElementById('hotel-trust-reviews'),
) {
  once(() => {
    attach(selector)
  })
  calculateHeight(selector)
}
